<i18n src="../translations"></i18n>

<template>
  <div>
    <div
      class="info-link qa-ProductCard__showCarTypes"
      role="button"
      tabindex="0"
      :aria-label="$t('product-info-sections.suitable-cars')"
      @click="show()"
      @keydown.enter.prevent="show()"
      @keydown.space.prevent="show()"
    >
      {{ $t('product-info-sections.suitable-cars') }}
      <ArrowOpenModalSvg class="info-arrow" />
    </div>

    <Dialog
      ref="carTypesDialog"
      class="pdp-info-dialog"
      :click-outside="true"
      :title="$t('product-info-sections.suitable-cars')"
      :use-frame-padding="false"
    >
      <PdpCarTypesTable
        :product-id="productId"
        @empty="$emit('empty', 'carTypes')"
      />
    </Dialog>
  </div>
</template>

<script>
import ArrowOpenModalSvg from 'Components/00-generated/ArrowOpenModalSvg';
import Dialog from 'Components/02-molecules/dialog/Dialog';
import PdpCarTypesTable from './PdpCarTypesTable.vue';

export default {
  name: 'PdpInfoCarLink',
  components: { ArrowOpenModalSvg, Dialog, PdpCarTypesTable },
  props: {
    productId: { type: String, required: true },
  },
  methods: {
    show() {
      if (!this.productId) return;
      this.$refs.carTypesDialog.show();
    },
  },
};
</script>

<style scoped lang="scss">
@import './_linkBase.scss';

.info-link {
  margin-bottom: var(--space-3);
}
</style>
